<template>
	<div>
		<el-input type="textarea" :rows="2" placeholder="请输入和编辑人员的沟通内容" v-model="feedback">
		</el-input>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				cbId: 0,
				feedback: ""
			};
		},
		methods: {
			init(cbId) {
				console.log(cbId);
				this.cbId = cbId || 0;
			},

			yes(close) {
				console.log(this.cbId);
				if (this.feedback == "") {
					this.alertError("沟通内容不能为空");
					return;
				}
				this.$api.contribute
					.setFeedback(this.cbId,this.feedback)
					.then((res) => {
						if (res.Status == 1) {
							this.alert("提交成功", 1000);
							this.$emit("ok");
							close();
						} else {
							this.alertError("提交失败，请重新尝试");
						}
					})
			}

		},
	};
</script>

<style>
</style>